import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { FlameIcon } from './ui/icons/flame-icon';
import { useAuth } from '@/hooks/useAuth';
import { VersionPill } from '@/components/ui/version-pill';

export function NotFound() {
	const [isHovered, setIsHovered] = React.useState(false);
	const { user, isAdmin, isLoading } = useAuth();
	const isSignedIn = Boolean(user) && !isLoading;
	const navigate = useNavigate();

	return (
		<div className='flex h-screen w-full flex-col relative'>
			<div className='orb-container pointer-events-none'>
				<div className='orb orb-1'></div>
				<div className='orb orb-2'></div>
				<div className='orb orb-3'></div>
				<div className='orb orb-4'></div>
				<div className='orb orb-5'></div>
			</div>
			<div className='absolute inset-0 bg-white/10 dark:bg-black/40 z-[1]' />
			<main className='flex grow flex-col relative z-[2]'>
				<div className='container mx-auto p-6 flex flex-col items-center justify-center min-h-screen'>
					<div className='w-full max-w-3xl mx-auto text-center glass-morphism p-8 rounded-lg'>
						<div className='flex flex-col items-center space-y-2'>
							<img
								src='/logo.png'
								alt='Prometheus'
								className='w-[300px] h-auto mb-4'
							/>
							<h1 className='text-7xl font-bold text-pink-500 mb-2'>
								404
							</h1>
							<p className='text-3xl text-orange-500 mb-4'>
								Looks Like The Fire Went Out
							</p>
							<p className='text-xl text-gray-300 mb-8'>
								The page you're looking for has vanished into
								the ethereal flames.
							</p>
						</div>
						<div className='pt-8 flex flex-col gap-4 items-center'>
							<Button
								size='lg'
								onMouseEnter={() => setIsHovered(true)}
								onMouseLeave={() => setIsHovered(false)}
								className='bg-gradient-to-b from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white px-12 py-6 h-auto w-64'
								onClick={() => {
									if (!isSignedIn) {
										navigate('/');
									} else {
										navigate(isAdmin ? '/admin' : '/user');
									}
								}}
							>
								<div className='flex items-center justify-center gap-1.5'>
									<FlameIcon isHovered={isHovered} />
									<span className='text-2xl font-semibold'>
										{isSignedIn ? 'DASHBOARD' : 'HOME'}
									</span>
								</div>
							</Button>
						</div>
					</div>
				</div>
			</main>
			<VersionPill />
		</div>
	);
}
